import { t } from '@lingui/core/macro';
import { Chip, useToast } from '@pocketlaw/tetris';
export function DocumentIdChip(props) {
    const { id } = props;
    const { addToast } = useToast();
    const copyToClipboard = () => {
        navigator.clipboard.writeText(id).then(() => {
            addToast({
                appearance: 'success',
                title: t({
                    message: 'Copied ID to clipboard',
                    comment: 'Copy ID to clipboard toast success message',
                }),
            });
        });
    };
    return (<Chip size="medium" label={t({ message: 'Document id', comment: 'Label for document id' })} secondary={id} appearance="secondary" onClick={copyToClipboard}/>);
}
